









































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { AdditionalCardholder } from '@/store/consumer-application/types';
import { requiredRule, characterCountRule } from '@/form-rules';

@Component
export default class AdditionalCardholderFields extends Vue {
    additionalCardholder: AdditionalCardholder = {
		firstName: '',
		middleInitial: '',
		lastName: '',
		suffix: '',
		nameOnCard: '',
		dateOfBirth: '',
		ssn: '',
	};

	additionalCardholderChecked = false;
	dateOfBirthMenu = false;

	data() {
		return {
			firstNameRules: [
				requiredRule('First Name is required'),
				characterCountRule('First Name', 50),
			],
			lastNameRules: [
				requiredRule('Last Name is required'),
				characterCountRule('Last Name', 50),
			],
			nameOnCardRules: [
				requiredRule('Name on Card is required'),
				characterCountRule('Name on Card', 200),
			],
			dateOfBirthRules: [
				requiredRule('Date of Birth is required'),
			],
			socialSecurityNumberRules: [
				requiredRule('Social Security Number is required'),
			],
		};
	}


	additionalCardholderClicked() {
		if (!this.additionalCardholderChecked) {
			this.additionalCardholder.firstName = '';
			this.additionalCardholder.middleInitial = '';
			this.additionalCardholder.lastName = '';
			this.additionalCardholder.suffix = '';
			this.additionalCardholder.nameOnCard = '',
			this.additionalCardholder.dateOfBirth = '',
			this.additionalCardholder.ssn = '';

			this.updateAdditionalCardholder();
		}
	}

	updateAdditionalCardholder () {
		this.$store.commit('consumerApplication/SET_ADDITIONAL_CARDHOLDER_FIELDS', this.additionalCardholder, { root: true });
	}

}
